import { makeStyles, type Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
	container: {
		height: '100%',
	},
	paper: {
		padding: theme.spacing(2),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: 500,
		maxWidth: '100%',
		height: 500,
		'& h5': {
			fontSize: 22,
			fontWeight: 500,
			color: theme.palette.text.primary,
			marginBottom: 24,
		},
		'& p': {
			fontSize: 16,
			fontWeight: 500,
			marginBottom: 50,
		},
	},
}));

export default useStyles;
